import { useRef } from "react"

import Style from "./style"
import editImage from "./asset/edit_image.svg"

import DefaultSlideModal from "shared/ui/DefaultSlideModal"
import DefaultButton from "shared/ui/DefaultButton"

import usePostUtilUpload from "entity/util/usePostUtilUpload"
import usePutAccountProfile from "entity/account/usePutAccountProfile"

const ProfileModal = ({ profile, closeEvent }) => {
    const inputFileRef = useRef()
    const profileImgRef = useRef()

    const [uploadPath, changeFileEvent] = usePostUtilUpload()
    const [putProfile] = usePutAccountProfile()

    return (
        <DefaultSlideModal title="프로필 이미지 수정" closeEvent={closeEvent}>
            <Style.Content>
                <Style.ProfileButton onClick={() => inputFileRef.current.click()}>
                    <input type="file" ref={inputFileRef} onChange={changeFileEvent} style={{ display: "none" }} />
                    <Style.ProfileImage src={uploadPath || profile} ref={profileImgRef} />
                    <Style.ProfileOption src={editImage} />
                </Style.ProfileButton>
                <p>jpg, png 이미지 / 20mb 이하</p>
            </Style.Content>
            <DefaultButton clickEvent={() => putProfile(uploadPath)}>수정하기</DefaultButton>
        </DefaultSlideModal>
    )
}

export default ProfileModal